// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_3k-2";
export var blackBorderOnHover = "_3k-7";
export var cell = "_3k-6";
export var cellContainer = "_3k-3";
export var checked = "_3k-8";
export var disabled = "_3k-5";
export var featuredIconCellContainer = "_3k-9";
export var featuredIconTextContainer = "_3k-b";
export var featuredIconWrapper = "_3k-a";
export var noBorder = "_3k-c";
export var orangeSelectedRow = "_8o-3";
export var overflowableText = "_3k-0";
export var overflowableTextContainer = "_3k-1";
export var row = "_3l-0";
export var rowCheckboxCell = "_3k-4";
export var selectableTable = "_8o-2";